// extracted by mini-css-extract-plugin
module.exports = {"container":"signin_container_2Yi_K","box":"signin_box_1suU8","button1":"signin_button1_3DvPU","button2":"signin_button2_13nV3"};